import { getCurrentPath } from '@framework/router';

export const isItemActive = (
  itemLink: string | { pathname: string, query?: Record<string, string> },
  currentPath: string,
  exactMatch: boolean = false,
): boolean => {
  if (!itemLink) {
    return false;
  }

  const normalizedItemPath = typeof itemLink === 'string'
    ? getCurrentPath(itemLink)
    : itemLink.pathname;

  if (exactMatch) {
    return normalizedItemPath === currentPath;
  }

  return currentPath === normalizedItemPath ||
         currentPath.startsWith(`${ normalizedItemPath }/`);
};
